/**
 * @description: 开房套餐价格
 * @author: ct
 * @update: hwx
 * @update: lyr
 * @update: wgt
 */
<template>
	<div class="package-price">
		<div class="pprice-list" v-show="showList">
			<div class="row row-margin">
				<button class="btn btn-flat btn-large btn-orange bigbtn" @click="addPPrice" v-if="list_menu_add">新增开房套餐价格</button>
				<button type="button" class="btn bg-orange btn-flat bigbtn"><a href="https://vodonline.g-hi.com/Download/packageImportTemplate.xls">开房套餐导入模板下载</a></button>
				<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addXlsFun">导入开房套餐</button>
            	<input type="file" @change="uploadXls($event)" ref="xlsFile" id="xlsFile">
			</div>
			<div class="row row-margin">
				<label class="list-label-2">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="pprice_shop"></select>
				</div>
				<label class="list-label-4">包厢类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="pprice_boxtype"></select>
				</div>
				<label class="list-label-4">套餐类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="pprice_type">
						<option value="0">全部</option>
						<option value="1">时间套餐</option>
						<option value="2">酒水套餐</option>
						<option value="3">最低消费套餐</option>
						<option value="4">团购套餐</option>
					</select>
				</div>
				<label class="list-label-4">状态类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="pprice_status">
						<option value="1">启用</option>
						<option value="-1">禁用</option>
					</select>
				</div>
			</div>
			<div class="row">
				<label class="list-label-4">在线预订:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="pprice_order">
						<option value="0">全部</option>
						<option value="1">是</option>
						<option value="-1">否</option>
					</select>
				</div>
				<label class="list-label-4">套餐名称:</label>
				<div class="col-md-2">
					<input type="text" class="form-control" placeholder="请输入套餐名称" v-model="pprice_name">
				</div>
				<label class="list-label-4">适用日期:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="pprice_datetype">
						<option value="0">全部</option>
						<option value="1">进行中</option>
						<option value="2">未开始</option>
						<option value="3">已过期</option>
					</select>
				</div>
				<div class="pull-right">
					<button type="button" class="btn bg-orange btn-flat btn-middle" @click="multiSet">开房套餐批量修改</button>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryList">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="pprice_list"></table>
			</div>
		</div>
		<!-- 开房套餐批量修改 -->
		<div class="multi-set-pop ele-hide" ref="serv_rate">
			<div class="row">
				<label class="col-md-3">门店：</label>
				<div class="col-md-8 ct-col">
					<select class="form-control" data-placeholder="请选择门店" ref="serv_rate_shop"></select>
				</div>      
			</div>
			<div class="row">
				<label class="col-md-3">开房套餐类型：</label>
				<div class="col-md-8">
					<input class="form-control input-readonly" placeholder="请选择开房套餐类型" v-model="serv_rate_txt" ref="serv_rate_txt" @click="openGoodtype($event)" readonly>
					<span class="selection-clear" @click="clearInput('serv_rate_txt')">×</span>
					<span class="span-arrow" role="presentation"><b></b></span>
				</div>
			</div>
			<div class="red-tip">请勾选要编辑的项目</div>
			<div class="row" v-for="(item, index) in multi_config" :key="index">
                <el-checkbox v-model="item.check"></el-checkbox>
                <label v-if="item.key==='vip_present_pay' || item.key==='vip_points_pay' || item.key==='included_give_ratio'" class="el-form-item__label beyond">{{item.label}}</label>
                <label v-else class="el-form-item__label">{{item.label}}</label>
                <el-select v-if="item.type==='select'" v-model="item.value" :disabled="!item.check">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="-1"></el-option>
                </el-select>
                <el-input v-else :placeholder="item.placeholder" v-model="item.value" :disabled="!item.check">
                    <template slot="append">{{item.unit}}</template>
                </el-input>
            </div>
		</div>
		<!-- 开房套餐类型 -->
        <div class="ele-hide" ref="serv_rate_alert">
            <div class="multi-select">
                <div class="clearfix">
                    <input type='checkbox' v-model='serv_rate_all' @click='servRateCheckAll'>
                    <span>全选</span>
                </div>
                <ul class="clearfix">
                    <li>
                        <input type="checkbox" v-model='serv_rate_item' value="1">
                        <span>时间套餐</span>
                    </li>
                    <li>
                        <input type="checkbox" v-model='serv_rate_item' value="2">
                        <span>酒水套餐</span>
                    </li>
                    <li>
                        <input type="checkbox" v-model='serv_rate_item' value="3">
                        <span>最低消费套餐</span>
                    </li>
                    <li>
                        <input type="checkbox" v-model='serv_rate_item' value="4">
                        <span>团购套餐</span>
                    </li>
                </ul>
            </div>
        </div>
		<div class="pprice-edit" v-show="!showList">
			<p class="page-tit">{{modify=="edit"?"修改":"新增"}}开房套餐价格</p>
			<div class="row">
				<label class="ctr-label-left">选择门店</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_shop" data-placeholder="请选择门店"></select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">显示顺序</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入显示顺序" v-model="edit_listorder" />
					<span class="kfpkg-vip-hint">显示顺序数字大的在显示端显示靠前</span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">套餐名称</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_name" data-placeholder="请选择开房套餐名称">
						<option value=""></option>
					</select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">套餐类型</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="根据开房套餐的名称自动显示" readonly v-model="edit_type" />
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">时长</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="根据开房套餐的名称自动显示" readonly v-model="edit_duration" />
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">时长原价</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入时长原价(仅显示作用)" v-model="edit_duration_price" />
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">时间成本价</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入时间成本价（选填）" v-model="edit_time_cost" />
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">原      价</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="套餐原价(仅显示作用)" v-model="edit_original_cost" disabled />
				</div>
				<span class="rmarkspan" titles="原价是用仅起到显示作用，终端删除线显示：<br/>如：原价<span class='lineThrough'>200</span>元      优惠价150元。<br/>推荐使用：系统显示原价（时长原价+套餐商品的原价）" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">优 惠 价</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入套餐优惠价(套餐实际售价)" v-model="edit_discount_price" />
				</div>
				<span class="rmarkspan" titles="优惠价是非会员消费者购买商品后的最后支付价。<br/>终端删除线显示如：原价<span class='lineThrough'>200</span> 优惠价150" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">会 员 价</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="填写会员价，会员价是使用会员卡后享受的价格（选填）" v-model="edit_vip_price">
					<span class="kfpkg-vip-hint">会员价设置为0或不填时等于优惠价</span>
				</div>
				<span class="rmarkspan" titles="注册成为会员后享受的价格。场所如果有设置会员打折和会员价的话会同时起作用。" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">团购结算价</label>
				<div class="col-md-6">
					<input type="text" class="form-control input-readonly" placeholder="只使用团购套餐填写（选填）" v-model="edit_group_price" ref="edit_group_price" readonly disabled @click="fillGroupPop" />
					<span class="selection-clear" @click="clearInput('edit_group_price')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">适用包厢类型</label>
				<div class="col-md-6">
					<input type="text" placeholder="请选择包厢类型" readonly class="form-control input-readonly" @click="editBoxTypeFun" v-model="edit_box_type" ref="edit_box_type" />
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">使用时间</label>
				<div class="col-md-6">
					<input type="text" placeholder="请输入使用时间" readonly class="form-control input-readonly" v-model="edit_use_time" @click="editUseTimeFun" />
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">有效星期日</label>
				<div class="col-md-6">
					<input type="text" class="form-control input-readonly" placeholder="请选择有效星期日" v-model="edit_week_txt" ref="edit_week_txt" readonly @click="editWeekFun($event)">
					<span class="selection-clear" @click="clearInput('edit_week_txt')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">不可用日期</label>
				<div class="col-md-6 pkg-disdate">
					<div class="time-wrapper" ref="pkg_disdate">
						<input type="text" class="form-control input-readonly" placeholder="请选择不可用日期（选填）" v-model="edit_disdate" ref="edit_disdate" readonly>
					</div>
					<span class="selection-clear" @click="clearInput('edit_disdate')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<div class="pkg-use-time clearfix">
					<label class="ctr-label-left">适用日期</label>
					<div class="col-md-6">
						<div class="time-wrapper" ref="pkg_use_time">
							<input type="text" class="form-control input-readonly" placeholder="请选择适用日期" v-model="edit_use_date" ref="edit_use_date" readonly>
						</div>
						<span class="selection-clear" @click="clearInput('edit_use_date')">×</span>
						<span class="span-arrow"><b></b></span>
					</div>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">商品是否允许打折</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_is_discount" data-placeholder="是否会员打折">
						<option value="1">是</option>
						<option value="-1">否</option>
					</select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">服务费收取比例</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入数字，如1，2，3..." v-model="edit_serv_perc" />
				</div>
				<div class="ctr-hint-txt">%</div>
				<span class="rmarkspan" titles="设置为0则不收服务费，设置0以上的数字则在结账时包厢账单按该商品设置的比例收取服务费。" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">消费者端显示</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_is_cshow" data-placeholder="消费者端是否显示">
						<option value="1">是</option>
						<option value="-1">否</option>
					</select>
				</div>
				<span class="rmarkspan" titles="【是】：在触摸屏，智慧商家app，微信端，支付宝端均显示。<br />【否】：只在智慧商家app端显示。" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">算订台业绩</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_is_dt" data-placeholder="是否算订台业绩">
						<option value="1">是</option>
						<option value="-1">否</option>
					</select>
				</div>
			</div>
			<div class="row" v-show="vip_shareholder_status">
				<label class="ctr-label-left">预估成本价</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入预估成本价" v-model="edit_forecast_cost" />
				</div>
				<span class="rmarkspan" titles="用以计算商品利润的一个数值<br />商品利润=（商品折后价-预估成本价）*毛利" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row" v-show="vip_shareholder_status">
				<label class="ctr-label-left">毛利百分比</label>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入毛利百分比" v-model="edit_gross_ratio" />
				</div>
				<div class="ctr-hint-txt">%</div>
				<span class="rmarkspan" titles="用以计算商品利润的一个数值<br />商品利润=（商品折后价-预估成本价）*毛利" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left" style="line-height: normal">是否计入可赠送比例</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_is_give_ratio" data-placeholder="是否计入可赠送比例">
						<option value="1">是</option>
						<option value="-1">否</option>
					</select>
				</div>
				<span class="rmarkspan" titles="该开房套餐是否计入账单消费金额，用于计算赠送金额比例<br />【是】计入账单消费金额，可用于赠送金额比例<br />【否】不计入账单消费金额，即不可用于赠送金额比例" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">开房时是否可用</label>
				<div class="col-md-6 radio-choose">
					<input type="radio" name="isOpenBox" class="" value="">
					<label>是</label>
					<input type="radio" name="isOpenBox" class="" value="">
					<label>否</label>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">续费时是否可用</label>
				<div class="col-md-6 radio-choose">
					<input type="radio" name="isrenew" class="" value="">
					<label>是</label>
					<input type="radio" name="isrenew" class="" value="">
					<label>否</label>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">跨时段是否可用</label>
				<div class="col-md-6 radio-choose">
					<div class="pull-left">
						<input type="radio" name="isCrossTime" class="" value="">
						<label>是</label>
						<input type="radio" name="isCrossTime" class="" value="">
						<label>否</label>
					</div>
					<span class="rmarkspan" titles="例如：消费者在17：00购买了【3小时500元酒水开房套餐】<br/>（使用时间是当日12：00-当日18：00）。<br/>跨时段收费设置【是】，消费者支付500元可以唱到20：00结束。<br/>跨时段收费设置【否】，消费者支付500元可以唱到18：00结束" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
				</div>
			</div>
			<div class="row" v-show="edit_type=='团购套餐'">
				<label class="ctr-label-left">现场购买</label>
				<div class="col-md-6 radio-choose">
					<div class="pull-left">
						<input type="radio" name="can_scene_buy" class="" value="">
						<label>是</label>
						<input type="radio" name="can_scene_buy" class="" value="">
						<label>否</label>
					</div>
					<span class="rmarkspan" titles="说明：默认团购套餐只能使用团购券核销开房方式，<br/>设置现场购买为“是”后，app端可支持现场支付购买该团购套餐" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
				</div>
			</div>
			<div class="row row-margin">
				<h5>—— 不同会员等级会员价设置 ——</h5>
				<div class="row">
					<label class="ctr-label-left">一级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写一级会员等级享受的会员价" v-model.trim="vip_level1_price">
					</div>
					<label class="ctr-label-left">二级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写二级会员等级享受的会员价" v-model.trim="vip_level2_price">
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">三级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写三级会员等级享受的会员价" v-model.trim="vip_level3_price">
					</div>
					<label class="ctr-label-left">四级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写四级会员等级享受的会员价" v-model.trim="vip_level4_price">
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">五级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写五级会员等级享受的会员价" v-model.trim="vip_level5_price">
					</div>
					<label class="ctr-label-left">六级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写六级会员等级享受的会员价" v-model.trim="vip_level6_price">
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">七级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写七级会员等级享受的会员价" v-model.trim="vip_level7_price">
					</div>
					<label class="ctr-label-left">八级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写八级会员等级享受的会员价" v-model.trim="vip_level8_price">
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">九级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写九级会员等级享受的会员价" v-model.trim="vip_level9_price">
					</div>
					<label class="ctr-label-left">十级会员价:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="填写十级会员等级享受的会员价" v-model.trim="vip_level10_price">
					</div>
				</div>
			</div>
            <div class="row" v-if="edit_type=='时间套餐' && shop_list.length > 0">
                <div class="shop-sync-message">
                    <div class="shop-sync-message-title">资料同步<span class="shop-sync-message-title-span">(以下门店如需更新当前商品资料请勾选)</span></div>
                    <div class="shop-multi-select">
                        <div class="select-header">
                            <el-checkbox v-model="isAllSelected" @change="handleSelectAllShops">全选</el-checkbox>
                        </div>
                        <div class="shop-list">
                            <el-checkbox-group v-model="selected_shops" class="shop-checkbox-group">
                                <el-checkbox v-for="shop in shop_list" :key="shop.id" :label="shop.id" class="shop-checkbox-item">
                                    {{shop.text}}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>
			<div class="row set-price-row" ref="edit_book_wrap" v-if="business_model != 2">
				<div class="row">
					<label class="ctr-label-left">在线预订</label>
					<div class="col-md-6 ct-col">
						<select class="form-control" ref="eidt_is_book" data-placeholder="是否微信预订">
							<option value="1">是</option>
							<option value="-1">否</option>
						</select>
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">每日可订数量</label>
					<div class="col-md-6">
						<input type="text" class="form-control" placeholder="请输入每日可订数量" v-model="edit_book_num" ref="edit_book_num" maxlength="4" />
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">预订优惠价</label>
					<div class="col-md-6">
						<input type="text" class="form-control" placeholder="请输入预定优惠价" v-model="edit_book_discount" ref="edit_book_discount" />
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">预订一级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订一级会员价" v-model="book_vip_level1_price" ref="book_vip_level1_price" />
					</div>
					<label class="ctr-label-left">预订二级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订二级会员价" v-model="book_vip_level2_price" ref="book_vip_level2_price" />
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">预订三级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订三级会员价" v-model="book_vip_level3_price" ref="book_vip_level3_price" />
					</div>
					<label class="ctr-label-left">预订四级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订四级会员价" v-model="book_vip_level4_price" ref="book_vip_level4_price" />
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">预订五级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订五级会员价" v-model="book_vip_level5_price" ref="book_vip_level5_price" />
					</div>
					<label class="ctr-label-left">预订六级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订六级会员价" v-model="book_vip_level6_price" ref="book_vip_level6_price" />
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">预订七级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订七级会员价" v-model="book_vip_level7_price" ref="book_vip_level7_price" />
					</div>
					<label class="ctr-label-left">预订八级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订八级会员价" v-model="book_vip_level8_price" ref="book_vip_level8_price" />
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">预订九级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订九级会员价" v-model="book_vip_level9_price" ref="book_vip_level9_price" />
					</div>
					<label class="ctr-label-left">预订十级会员价</label>
					<div class="col-md-4">
						<input type="text" class="form-control" placeholder="预订十级会员价" v-model="book_vip_level10_price" ref="book_vip_level10_price" />
					</div>
				</div>
				<div class="row">
					<label class="ctr-label-left">在线预订备注</label>
					<div class="col-md-6">
						<textarea class="form-control book-remark" placeholder="请输入在线预订备注" v-model="edit_book_remark" ref="edit_book_remark"></textarea>
					</div>
				</div>
			</div>
			<div class="holiday-set" v-show="modify=='edit'">
				<div class="row block-title">节假日价格设置</div>
				<el-button type="primary" size="small" @click="addNewHolidayPrice">新增</el-button>
				<el-table
					class="holiday-table"
	                v-loading="holiday_loading"
	                element-loading-text="努力加载中，请稍后..."
	                element-loading-background="rgba(0, 0, 0, 0.6)"
	                :data="holiday_list">
	                <el-table-column prop="name" label="节假日名称"></el-table-column>
	                <el-table-column label="适用日期" width="400">
						<template slot-scope="scope">{{scope.row.enable_start_time+'~'+scope.row.enable_end_time}}</template>
	                </el-table-column>
	                <el-table-column prop="actual_price" label="优惠价"></el-table-column>
	                <el-table-column prop="vip_price" label="会员价"></el-table-column>
	                <el-table-column label="操作">
						<template slot-scope="scope">
							<span class="text-blue" @click="editHoliday(scope.row)">修改</span>
							<span class="text-blue" @click="delHoliday(scope.row.id)">删除</span>
						</template>
	                </el-table-column>
	            </el-table>
	            <el-pagination
	                background
	                layout="total, prev, pager, next, jumper"
	                :page-size="GLOBAL.PAGESIZE"
	                :current-page.sync="holiday_page"
	                :total="holiday_total"
	                @current-change="getHoladayList">
	            </el-pagination>
			</div>
			<div class="row">
				<button type="button" class="btn btn-middle btn-flat btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-middle bg-orange btn-flat sub-margin" @click="saveEdit">确定</button>
			</div>
			<!-- 团购结算价弹窗 -->
			<div class="pkg-group-pop" ref="pkg_group_pop">
				<el-form v-model="group_type_list">
					<el-form-item :label="item.name" v-for="item in group_type_list" label-width="120px">
						<el-input v-model="item.price"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<!-- 包厢类型弹窗 -->
			<div class="ele-hide" ref="boxtype_alert">
				<div class="multi-select">
					<div class="clearfix">
						<input type='checkbox' v-model='boxtype_all' @click='boxtypeAll'>
						<span>全选</span>
					</div>
					<ul class="clearfix">
						<li v-for="item in boxtype_arr" :key="item.id">
							<input type="checkbox" v-model='boxtype_item' :value="item.id">
							<span>{{item.name}}</span>
						</li>
					</ul>
				</div>
			</div>
			<!-- 时间选择弹窗 -->
			<div class="use-time-wrap" ref="pprice_use_time">
				<h2>开始时间：</h2>
				<select ref="starthour"></select>
				<label class="colon">:</label>
				<select ref="startseconds"></select>
				<h2>结束时间：</h2>
				<select ref="stophour"></select>
				<label class="colon">:</label>
				<select ref="stopseconds"></select>
			</div>
			<!--星期选择弹窗-->
			<div class="ele-hide" ref="week_alert">
				<div class="multi-select">
					<div class="clearfix">
						<li>
							<input type='checkbox' v-model='week_all' @click='weekAll'>
							<label>全选</label>
						</li>
					</div>
					<ul class="clearfix">
						<li>
							<input type="checkbox" v-model='week_item' value="1">
							<label>星期一</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="2">
							<label>星期二</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="3">
							<label>星期三</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="4">
							<label>星期四</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="5">
							<label>星期五</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="6">
							<label>星期六</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_item' value="0">
							<label>星期日</label>
						</li>
					</ul>
				</div>
			</div>
			<!-- 节假日价格设置弹窗 -->
			<div class="holiday-pop ele-hide" ref="holiday_pop">
				<el-form :inline="true" label-width="120px">
					<el-form-item label="节假日名称" required>
						<el-input v-model="holiday_add_form.name" placeholder="请输入节假日名称"></el-input>
					</el-form-item>
					<el-form-item label="适用日期" required>
						<div class="holiday-time" ref="holiday_time">
							<el-input v-model="holiday_add_form.timeStr" placeholder="请选择适用日期" readonly></el-input>
						</div>
					</el-form-item>
					<el-form-item label="优惠价" required>
						<el-input v-model="holiday_add_form.actual_price" placeholder="请输入金额"></el-input>
					</el-form-item>
					<el-form-item label="会员价">
						<el-input v-model="holiday_add_form.vip_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="预定价" v-show="showHolidayBookBlock">
						<el-input v-model="holiday_add_form.book_actual_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<div class="pop-block-title">—— 不同会员等级会员价设置 ——</div>
					<el-form-item label="一级会员价">
						<el-input v-model="holiday_add_form.vip_level1_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="二级会员价">
						<el-input v-model="holiday_add_form.vip_level2_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="三级会员价">
						<el-input v-model="holiday_add_form.vip_level3_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="四级会员价">
						<el-input v-model="holiday_add_form.vip_level4_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="五级会员价">
						<el-input v-model="holiday_add_form.vip_level5_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="六级会员价">
						<el-input v-model="holiday_add_form.vip_level6_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="七级会员价">
						<el-input v-model="holiday_add_form.vip_level7_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="八级会员价">
						<el-input v-model="holiday_add_form.vip_level8_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="九级会员价">
						<el-input v-model="holiday_add_form.vip_level9_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<el-form-item label="十级会员价">
						<el-input v-model="holiday_add_form.vip_level10_price" placeholder="请输入金额"></el-input>	
					</el-form-item>
					<!-- 是团购套餐并且支持预定 -->
					<div class="book-block" v-show="showHolidayBookBlock"> 
						<div class="pop-block-title">—— 在线预定不同会员等级金额设置 ——</div>
						<el-form-item label="预定一级会员价">
							<el-input v-model="holiday_add_form.book_vip_level1_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定二级会员价">
							<el-input v-model="holiday_add_form.book_vip_level2_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定三级会员价">
							<el-input v-model="holiday_add_form.book_vip_level3_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定四级会员价">
							<el-input v-model="holiday_add_form.book_vip_level4_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定五级会员价">
							<el-input v-model="holiday_add_form.book_vip_level5_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定六级会员价">
							<el-input v-model="holiday_add_form.book_vip_level6_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定七级会员价">
							<el-input v-model="holiday_add_form.book_vip_level7_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定八级会员价">
							<el-input v-model="holiday_add_form.book_vip_level8_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定九级会员价">
							<el-input v-model="holiday_add_form.book_vip_level9_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
						<el-form-item label="预定十级会员价">
							<el-input v-model="holiday_add_form.book_vip_level10_price" placeholder="请输入金额"></el-input>	
						</el-form-item>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		data() {
			return {
            	vip_shareholder_status: '',
				showList: true,
				modify: "edit",

				list_menu_add: false,
            	list_menu_op: [],
				pprice_name: "",
				pprice_recommend: '',
				pprice_op: '',
				serv_rate_txt: "",
				serv_rate_all: false,
				c_serv_rate_all: false,
				serv_rate_item: [],
				serv_rate_arr: [{id: '1', name: '时间套餐'}, {id: '2', name: '酒水套餐'}, {id: '3', name: '最低消费套餐'}, {id: '4', name: '团购套餐'}],
				serv_rate_num: '',

				edit_id: '',
				edit_type: '',
				edit_listorder: '',
				edit_duration_minute: '',
				edit_duration_price: '',
				edit_time_cost: '',
				edit_pkg_price: '',
				edit_discount_price: '',
				edit_vip_price: "",
				edit_group_price: '',
				group_type_list: [], // 团购套餐类型
				pkg_groups: {},
				edit_box_type: '',
				boxtype_all: false,
				c_boxtype_all: false,
				boxtype_item: [],
				boxtype_arr: [],
				use_time_start: '',
				use_time_end: '',
				edit_week_txt: '',
				week_all: false,
				c_week_all: false,
				week_item: [],
				week_arr: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],
				edit_disdate: '',
				disdate_arr: [],
				edit_use_date: '不限制',
				enable_start_time: '',
				enable_end_time: '',
				edit_serv_perc: '',
				edit_forecast_cost: '',
				edit_gross_ratio: '',

				vip_level1_price: '',
				vip_level2_price: '',
				vip_level3_price: '',
				vip_level4_price: '',
				vip_level5_price: '',
				vip_level6_price: '',
				vip_level7_price: '',
				vip_level8_price: '',
				vip_level9_price: '',
				vip_level10_price: '',

				edit_book_num: '',
				edit_book_discount: '',
				book_vip_level1_price: '',
				book_vip_level2_price: '',
				book_vip_level3_price: '',
				book_vip_level4_price: '',
				book_vip_level5_price: '',
				book_vip_level6_price: '',
				book_vip_level7_price: '',
				book_vip_level8_price: '',
				book_vip_level9_price: '',
				book_vip_level10_price: '',
				edit_book_remark: '',

				// 节假日价格
				showHolidayBookBlock: false,
				holiday_loading: false,
				holiday_list: [],
				holiday_total: 0,
				holiday_page: 1,
				holiday_add_form: {
					relation_id: '',
					name: '',
					enable_start_time: '',
					enable_end_time: '',
					timeStr: '',
					actual_price: '', // 优惠价
					vip_price: '', // 会员价
					vip_level1_price: '', //会员等级价格
					vip_level2_price: '',
					vip_level3_price: '',
					vip_level4_price: '',
					vip_level5_price: '',
					vip_level6_price: '',
					vip_level7_price: '',
					vip_level8_price: '',
					vip_level9_price: '',
					vip_level10_price: '',
					book_actual_price: '', // 预定价格
					book_vip_level1_price: '', // 预定会员等级价格
					book_vip_level2_price: '', 
					book_vip_level3_price: '', 
					book_vip_level4_price: '', 
					book_vip_level5_price: '', 
					book_vip_level6_price: '', 
					book_vip_level7_price: '', 
					book_vip_level8_price: '', 
					book_vip_level9_price: '', 
					book_vip_level10_price: '', 
				},

				multi_config: [],
				multi_config_init: [{
	                type: 'select',
	                check: false,
	                label: '是否消费者端显示',
	                key: 'customer_show',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否允许打折',
	                key: 'discount_status',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否算订台业绩',
	                key: 'outstanding',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '是否计入可赠送比例',
	                key: 'included_give_ratio',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '开房时是否使用',
	                key: 'is_open_use',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '续费时是否使用',
	                key: 'is_renew',
	                value: '1'
	            }, {
	                type: 'select',
	                check: false,
	                label: '跨时段时是否使用',
	                key: 'consume_check_time',
	                value: '1'
	            }, {
	                type: 'input',
	                label: '服务费收取比例',
	                key: 'service_charge_rate',
	                value: '',
	                placeholder: '请输入服务费收取比例',
	                unit: '%'
	            }],
				selected_shops: [],
				shop_list: [], // [{id, text}]
                shop_list_all: [], // [{id, text}]
			}
		},
		
		watch: {
			serv_rate_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.serv_rate_txt).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.serv_rate_txt).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			serv_rate_item: {
				handler: function(val, oldVal) {
					if(this.serv_rate_item.length >= this.serv_rate_arr.length) {
						this.serv_rate_all = true;
						this.c_serv_rate_all = true;
					} else {
						this.serv_rate_all = false;
						this.c_serv_rate_all = false;
					}
				},
				deep: true
			},

			edit_group_price: {
				handler: function(val, oldval) {
					if(val != ""){
						$(this.$refs.edit_group_price).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_group_price).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},

			edit_week_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_week_txt).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_week_txt).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			week_item: {
				handler: function (val, oldVal) {
					if(this.week_item.length >= this.week_arr.length) {
						this.week_all = true;
						this.c_week_all = true;
					} else {
						this.week_all = false;
						this.c_week_all = false;
					}
				},
				deep: true
			},
			boxtype_item: {
				handler: function(val, oldVal) {
					if(this.boxtype_item.length >= this.boxtype_arr.length) {
						this.boxtype_all = true;
						this.c_boxtype_all = true;
					} else {
						this.boxtype_all = false;
						this.c_boxtype_all = false;
					}
				},
				deep: true
			},

			edit_disdate: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.edit_disdate).parent().parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_disdate).parent().parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			edit_use_date: {
				handler: function(val, oldval) {
					if(val != "不限制") {
						$(this.$refs.edit_use_date).parent().parent().find('.selection-clear').show();
					} else {
						$(this.$refs.edit_use_date).parent().parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			edit_type(newVal) {
				if (newVal !== '时间套餐') {
					this.selected_shops = [];
					this.isAllSelected = false;
				}
			}
		},
		created: function() {
			this.vip_shareholder_status = this.$store.state.privinfo.vip_shareholder_status
		},
		mounted: function() {
			let _this = this;
			_this.getMenuOp();
			$(_this.$refs.pprice_type).select2({
				language: "zh-CN",
				minimumResultsForSearch: -1,
				width: '100%'
			});
			$(_this.$refs.pprice_status).select2({
				language: "zh-CN",
				minimumResultsForSearch: -1,
				width: '100%'
			});
			$(_this.$refs.pprice_order).select2({
				language: "zh-CN",
				minimumResultsForSearch: -1,
				width: '100%'
			});
			$(_this.$refs.pprice_datetype).select2({
				minimumResultsForSearch: -1,
				language: "zh-CN",
				width: '100%'
			});
			this.$nextTick(function() {
				$(this.$refs.edit_is_discount).select2({
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});
				$(this.$refs.edit_is_discount).val(-1).trigger("change");
				$(this.$refs.edit_is_cshow).select2({
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});
				$(this.$refs.edit_is_dt).select2({
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});
				$(this.$refs.edit_is_give_ratio).select2({
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});

				$(this.$refs.eidt_is_book).select2({
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%',
					templateSelection: function(val) {
						if(val.text == '是') {
							$(_this.$refs.edit_book_num).prop("disabled", false);
							$(_this.$refs.edit_book_discount).prop("disabled", false);
							$(_this.$refs.book_vip_level1_price).prop("disabled", false);
							$(_this.$refs.book_vip_level2_price).prop("disabled", false);
							$(_this.$refs.book_vip_level3_price).prop("disabled", false);
							$(_this.$refs.book_vip_level4_price).prop("disabled", false);
							$(_this.$refs.book_vip_level5_price).prop("disabled", false);
							$(_this.$refs.book_vip_level6_price).prop("disabled", false);
							$(_this.$refs.book_vip_level7_price).prop("disabled", false);
							$(_this.$refs.book_vip_level8_price).prop("disabled", false);
							$(_this.$refs.book_vip_level9_price).prop("disabled", false);
							$(_this.$refs.book_vip_level10_price).prop("disabled", false);
							$(_this.$refs.edit_book_remark).prop("disabled", false);
							_this.showHolidayBookBlock = true
						} else if(val.text == '否') {
							$(_this.$refs.edit_book_num).val('').trigger('change');
							$(_this.$refs.edit_book_num).prop("disabled", true);
							$(_this.$refs.edit_book_discount).val('').trigger('change');
							$(_this.$refs.edit_book_discount).prop("disabled", true);
							$(_this.$refs.book_vip_level1_price).prop("disabled", true);
							$(_this.$refs.book_vip_level2_price).prop("disabled", true);
							$(_this.$refs.book_vip_level3_price).prop("disabled", true);
							$(_this.$refs.book_vip_level4_price).prop("disabled", true);
							$(_this.$refs.book_vip_level5_price).prop("disabled", true);
							$(_this.$refs.book_vip_level6_price).prop("disabled", true);
							$(_this.$refs.book_vip_level7_price).prop("disabled", true);
							$(_this.$refs.book_vip_level8_price).prop("disabled", true);
							$(_this.$refs.book_vip_level9_price).prop("disabled", true);
							$(_this.$refs.book_vip_level10_price).prop("disabled", true);
							$(_this.$refs.book_vip_level1_price).val('').trigger('change');
							$(_this.$refs.book_vip_level2_price).val('').trigger('change');
							$(_this.$refs.book_vip_level3_price).val('').trigger('change');
							$(_this.$refs.book_vip_level4_price).val('').trigger('change');
							$(_this.$refs.book_vip_level5_price).val('').trigger('change');
							$(_this.$refs.book_vip_level6_price).val('').trigger('change');
							$(_this.$refs.book_vip_level7_price).val('').trigger('change');
							$(_this.$refs.book_vip_level8_price).val('').trigger('change');
							$(_this.$refs.book_vip_level9_price).val('').trigger('change');
							$(_this.$refs.book_vip_level10_price).val('').trigger('change');
							$(_this.$refs.edit_book_remark).val('').trigger('change');
							$(_this.$refs.edit_book_remark).prop("disabled", true);
							_this.showHolidayBookBlock = false
						}
						return val.text
					}
				});
				this.getShopData();
				this.initDisdate();
				this.initUseTime();
				this.selectTime();

				this.getCplGoodsType();
			});
		},
		computed: {
			edit_duration() {
				let _this = this;
				
				if(_this.edit_duration_minute == "") {
					return "";
				} else {
					return _this.edit_duration_minute + "分钟(" + parseInt(_this.edit_duration_minute / 60) + "小时" + (_this.edit_duration_minute % 60) + "分钟)";
				}
			},
			edit_use_time() {
				return this.use_time_start + "-" + this.use_time_end;
			},
			edit_original_cost() {
				let _this = this;

				if(_this.edit_duration_price != "" || _this.edit_pkg_price != "") {
					return parseInt(_this.edit_pkg_price) + parseInt(_this.edit_duration_price);
				} else {
					return 0;
				}
			},
			isAllSelected: {
				get() {
                    return this.selected_shops.length === this.shop_list.length;
                },
                set(value) {
                    if (value) {
                        this.selected_shops = [...this.shop_list];
                    } else {
                        this.selected_shops = [];
                    }
                }
			},
			business_model() {
				return this.$store.state.business_model
			},
		},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = [];
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '542') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.id == '552') {
									menu = n.submenu;
								}
							});
						}
					});

					_this.list_menu_op = [{cls: 'text-blue recommend', name: '推荐'}, {cls: 'text-blue status', name: '状态'}, {cls: 'text-blue book', name: '预定'}];
					$.each(menu, function(x, y) {
						if(y.id == '921') {
							_this.list_menu_add = true;
							_this.list_menu_op.push({cls: 'text-blue copy-add', name: '复制新增'});
						}
						if(y.id == '922') {
							_this.list_menu_op.push({cls: 'text-blue edit', name: '修改'});
						}
						if(y.id == '923') {
							_this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
						}
					});
				}
			},
			// 提示语
			hint_language: function(e) {
				var contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
				layer.tips(contents, $(e.currentTarget), {
					skin: 'hint_language_tip',
					tips: [2, '#fff'],
					area: ['400px', ''],
					time: 2000000,
				});
			},
			// 关闭提示语
			close_hint_language: function() {
				layer.closeAll('tips');
			},
			// 获取门店数据
			getShopData() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
                            console.log('arr',arr);
                            
                            _this.shop_list_all = arr;
							$(_this.$refs.pprice_shop).select2({
								data: arr,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN"
							}).on("select2:select", function(e) {
								if(e.params.data.text == "全部") {
									$(_this.$refs.pprice_boxtype).val("").trigger('change');
									$(_this.$refs.pprice_boxtype).prop("disable", true);
									return;
								}
								$(_this.$refs.pprice_boxtype).prop("disabled", false);
								_this.getBoxType(e.params.data.id, 'list');
								_this.getShopGroupType(e.params.data.id)
							});
							$(_this.$refs.pprice_shop).val(data.response.result[1].id).trigger('change');
							$(_this.$refs.pprice_boxtype).prop("disabled", false);
							_this.getBoxType(data.response.result[1].id, 'list');
							_this.getShopGroupType(data.response.result[1].id)
							_this.initMainTable();

							arr.shift();
							$(_this.$refs.edit_shop).select2({
								data: arr,
								allowClear: false,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								// 套餐名称
								$(_this.$refs.edit_name).html('<option value=""></option>');
								$(_this.$refs.edit_name).val("").trigger('change');
                                console.log('e.params.data.id',e.params.data.id);
                                _this.shop_list = _this.shop_list_all.filter(item => item.id != e.params.data.id);
                                console.log('shop_list',_this.shop_list);
								_this.getPackageName(e.params.data.id);
								// 适用包厢类型
								_this.edit_box_type = '';
								_this.getBoxType(e.params.data.id, 'edit');
								_this.getShopGroupType(e.params.data.id)
							});

							$(_this.$refs.serv_rate_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});

			},
			// 获取包厢类型
			getBoxType(shop_id, type) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getRoomType",
					crossDomain: true,
					async: false,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [{id: ' ', text: '全部'}];
							$.each(data.response.result.data, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});

							if(type == 'list') {
								$(_this.$refs.pprice_boxtype).html('');
								$(_this.$refs.pprice_boxtype).select2({
									data: arr,
									minimumResultsForSearch: -1,
									language: "zh-CN"
								});
							} else if(type == 'edit') {
								_this.boxtype_arr = data.response.result.data;
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取商品类型
			getCplGoodsType: function() {
				let _this = this;
				
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [];
							$.each(data['response']['result']['data'], function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.serv_rate_type).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {}
				});
			},
			// 获取门店团购类型
			getShopGroupType(shop_id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopGroup",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result.result, function(k, v) {
								arr.push({ 
									id: v.id, 
									name: v.name,
									price: '' 
								});
							});
							_this.group_type_list = arr
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});

			},
			// 清空多选
			clearInput: function(name) {
				if(name == 'edit_week_txt') {
					this.edit_week_txt = "";
					this.week_item = [];
				} else if(name == 'edit_disdate') {
					this.edit_disdate = "";
					this.disdate_arr = [];
				} else if(name == 'edit_use_date') {
					this.edit_use_date = '不限制';
					this.enable_start_time = '';
					this.enable_end_time = '';
				} else if(name == 'edit_group_price') {
					this.edit_group_price = '';
					this.pkg_groups = {};
					this.getShopGroupType($(this.$refs.edit_shop).val())
				} else if(name == 'serv_rate_txt') {
					this.serv_rate_txt = '';
					this.serv_rate_item = [];
				}
			},
			// 不可用日期
			initDisdate: function() {
				let _this = this;
				$(_this.$refs.pkg_disdate).daterangepicker({
					parentEl: '.pkg-disdate',
					singleDatePicker: true, // 设置成单日历
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray'
				}, function(start, end, label) {
					_this.disdate_arr.push(start.format('YYYY-MM-DD'));
					_this.edit_disdate = _this.disdate_arr.join(',');
				});
			},
			// 适用日期
			initUseTime: function() {
				let _this = this;
				$(_this.$refs.pkg_use_time).daterangepicker({
					parentEl: '.pkg-use-time',
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray'
				}, function(start, end, label) {
					_this.edit_use_date = start.format('YYYY-MM-DD HH:mm') + ' - ' + end.format('YYYY-MM-DD HH:mm');
					_this.enable_start_time = start.format('YYYY-MM-DD HH:mm');
					_this.enable_end_time = end.format('YYYY-MM-DD HH:mm');
				});
			},

			// 初始化
			initMainTable: function() {
				let _this = this;

				$(_this.$refs.pprice_list).bootstrapTable("destroy");
				$(_this.$refs.pprice_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					ajax: function(params) {
						_this.getMainList(params);
					},
					sidePagination: "server",
					pagination: true,
					columns: [{
						field: "listorder",
						title: "显示<br />顺序",
						width: "5%",
						valign: "middle"
					}, {
						field: "shop_name",
						title: "门店",
						width: "8%",
						valign: "middle"
					}, {
						field: "package_type_name",
						title: "套餐类型",
						width: "7%",
						valign: "middle"
					}, {
						field: "package_name",
						title: "套餐名称",
						width: "7%",
						valign: "middle",
						formatter: function(value, row, index) {
							if(row.recommend == 1) {
								return "<div class='recommend-bg'>" + value + "</div>";
							} else {
								return value;
							}
						}
					}, {
						field: "package_time",
						title: "时长<br />/分钟",
						width: "6%",
						valign: "middle"
					}, {
						field: "price",
						title: "原价",
						width: "5%",
						valign: "middle"
					}, {
						field: "actual_price",
						title: "优惠价",
						width: "5%",
						valign: "middle"
					}, {
						field: "book_actual_price",
						title: "预定<br />优惠价",
						width: "7%",
						valign: "middle"
					}, {
						field: "book_day_num",
						title: "每日可订<br />数量",
						width: "7%",
						valign: "middle"
					}, {
						field: "week_cycle_str",
						title: "有效<br />星期日",
						width: "8%",
						valign: "middle"
					}, {
						field: "room_type_name",
						title: "适用包厢<br />类型",
						width: "7%",
						valign: "middle"
					}, {
						field: "start_time",
						title: "可使用时间",
						width: "7%",
						valign: "middle",
						formatter: function(value, row, index) {
							return row.start_time + "-" + row.end_time;
						}
					}, {
						field: "status",
						title: "状态",
						width: "3%",
						valign: "middle",
						formatter: function(value) {
							if(value == '1') {
								return "启用";
							} else {
								return "禁用";
							}
						}
					}, {
						field: "operation",
						title: "操作",
						width: "13%",
						valign: "middle",
						events: {
							'click .recommend': function(e, value, row, index) {
								let recommendtxt = ""
								if(row.recommend == 1) {
									_this.pprice_recommend = -1;
									recommendtxt = "确认取推吗?"
								} else {
									_this.pprice_recommend = 1;
									recommendtxt = "确认推荐吗?"
								}
								_this.edit_id = row.id;
								layer.confirm(recommendtxt, {
									btn: ['确定', '取消'], //按钮
								}, function() {
									_this.updatePackagePrice(1);
									layer.closeAll();
								});
							},
							'click .edit': function(e, value, row, index) {
								_this.edit_id = row.id;
								_this.getDet("edit");
							},
							'click .status': function(e, value, row, index) {
								let statustxt = "";
								if(row.status == 1) {
									_this.pprice_op = -1;
									statustxt = "确认禁用吗?"
								} else {
									_this.pprice_op = 1;
									statustxt = "确认启用吗?"
								}
								_this.edit_id = row.id;
								layer.confirm(statustxt, {
									btn: ['确定', '取消'], //按钮
								}, function() {
									_this.updatePackagePrice(2);
									layer.closeAll();
								});
							},
							'click .del': function(e, value, row, index) {
								_this.edit_id = row.id;
								_this.pprice_op = -2;
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消'], //按钮
								}, function() {
									_this.updatePackagePrice(2);
									layer.closeAll();
								});
							},
							'click .book': function(e, value, row, index) {
								let booktxt = ""
								if(row.book_status == 1) {
									_this.pprice_book = -1;
									booktxt = "确认下架吗?"
								} else {
									_this.pprice_book = 1;
									booktxt = "确认上架吗?"
								}
								_this.edit_id = row.id;
								layer.confirm(booktxt, {
									btn: ['确定', '取消'], //按钮
								}, function() {
									_this.updatePackagePrice(3);
									layer.closeAll();
								});
							},
							'click .copy-add': function(e, value, row, index) {
								_this.edit_id = row.id;
								_this.getDet("copy_add");
							},
						},
						formatter: function(value, row, index) {
							let recommend = row.recommend == '1' ? '取推' : '推荐';
							let status = row.status == '1' ? '禁用' : '启用';
							let book_status = row.book_status == '1' ? '预定下架' : '预定上架';

							let op_html = '';
							$.each(_this.list_menu_op, function(k, v) {
								if(v.name == '状态') {
									op_html += '<span class="'+ v.cls +'">'+ status +'</span>';
								} else if(v.name == '预定') {
									if(row.book_open == 1) {
										op_html += '<span class="'+ v.cls +'">'+ book_status +'</span>';
									}
								} else {
									op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>';
								}
							});
							return op_html;
						}
					}]
				})
			},
			getMainList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.pprice_shop).val(),
							"package_type": $(_this.$refs.pprice_type).val(),
							"package_name": _this.pprice_name,
							"room_type": $.trim($(_this.$refs.pprice_boxtype).val()),
							"status": $(_this.$refs.pprice_status).val(),
							"book_open": $(_this.$refs.pprice_order).val(),
							"expire_status": $(_this.$refs.pprice_datetype).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/getPackagePriceList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: []
							});
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 查询
			queryList: function() {
				this.initMainTable();
			},
			// 选择开房套餐类型
			openGoodtype: function(e) {
				let _this = this;
				let c_serv_rate_item = _this.serv_rate_item;
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], //按钮
					title: ['开房套餐类型', true],
					area: ['660px', ''], //宽高
					content: $(_this.$refs.serv_rate_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.serv_rate_txt != "") {
							_this.serv_rate_item = c_serv_rate_item;
							return;
						}
						_this.serv_rate_item = [];
					}
				}, function() {
					let texts = [];
					_this.serv_rate_arr.forEach(function(item) {
						_this.serv_rate_item.forEach(function(item2) {
							if(item.id == item2) {
								texts.push(item.name);
							}
						});
					});
					_this.serv_rate_txt = texts.join(",");

					if (_this.serv_rate_txt != '团购套餐') {
						let index = _this.multi_config.findIndex(item => item.key == 'can_scene_buy')
						if (index > -1) {
							_this.multi_config.splice(index, 1)
						}
					}else {
						let index = _this.multi_config.findIndex(item => item.key == 'can_scene_buy')
						if (index < 0) {
							_this.multi_config.push({
				                type: 'select',
				                check: false,
				                label: '现场购买',
				                key: 'can_scene_buy',
				                value: '-1'
				            })
				        }
					}
					layer.close(layer.index);
				}, function() {
					if(_this.serv_rate_txt != "") {
						_this.serv_rate_item = c_serv_rate_item;
						return;
					}
					_this.serv_rate_item = [];
				});
			},
			// 开房套餐类型全选
			servRateCheckAll: function() {
				let _this = this;
				_this.serv_rate_all = _this.c_serv_rate_all;
				if(!_this.serv_rate_all) { // 实现全选
					_this.serv_rate_item = [];
					_this.serv_rate_arr.forEach(function(item) {
						_this.serv_rate_item.push(item.id);
					});
				} else { // 实现反选
					_this.serv_rate_item = [];
				}
			},
			// 批量设置
			multiSet: function() {
				let _this = this;

				$(_this.$refs.serv_rate_shop).val('').trigger('change');
				_this.serv_rate_txt = "";
				_this.serv_rate_item = [];
				_this.multi_config = []
	            _this.multi_config_init.forEach(v => {
	                _this.multi_config.push({...v})
	            })
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'],
					title: ['开房套餐批量修改', true],
					area: ['600px', '600px'],
					content: $(_this.$refs.serv_rate),
					offset: '100px'
				}, function() {
					let config = {}
	                _this.multi_config.forEach(v => {
	                    if(v.check) {
	                        config[v.key] = v.value
	                    }
	                })
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"shop_id": $(_this.$refs.serv_rate_shop).val(),
								"package_type": _this.serv_rate_item,
								"config": config,
							}
						},
						"comment": ""
					};
					let datas2 = JSON.stringify(datas);
					$.ajax({
						type: "post",
						dataType: "json",
						url: Vue.ctUrl + "RoomPackage/batchUpdate",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: {
							json: datas2
						},
						success: function(data) {
							if(data.response.result_code == "true") {
								layer.closeAll();
								layer.msg("操作成功");
	                            $(_this.$refs.pprice_list).bootstrapTable("refresh");
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.msg("出错啦");
						}
					});
				});
			},
			// 点击新增
			addPPrice() {
				let _this = this;

				_this.modify = "add";
				$(_this.$refs.edit_shop).prop("disabled", false);
				$(_this.$refs.edit_shop).val("").trigger("change");
                console.log($(_this.$refs.edit_shop).val());
                _this.shop_list = _this.shop_list_all.filter(item => item.id != $(_this.$refs.edit_shop).val());
                console.log('shop_list',_this.shop_list);
                
				$(_this.$refs.edit_name).prop("disabled", false);
				$(_this.$refs.edit_name).val("").trigger("change");
				$(_this.$refs.edit_name).html('<option value=""></option>');
				_this.getPackageName($(_this.$refs.edit_shop).val());
				_this.edit_type = "";
				_this.edit_listorder = '';
				_this.edit_duration_minute = "";
				_this.edit_duration_price = "";
				_this.edit_time_cost = '';
				_this.edit_pkg_price = '';
				_this.edit_discount_price = "";
				_this.edit_vip_price = "";
				// 团购结算价
				$(_this.$refs.edit_group_price).attr("disabled", true);
				_this.edit_group_price = '';
				_this.getShopGroupType($(_this.$refs.edit_shop).val())
				
				$(_this.$refs.edit_box_type).prop("disabled", false);
				_this.edit_box_type = '';
				_this.boxtype_item = [];
				_this.getBoxType($(_this.$refs.edit_shop).val(), 'edit');
				_this.use_time_start = "00:00";
				_this.use_time_end = "00:00";
				_this.edit_week_txt = "";
				_this.week_item = [];
				// 不可用日期
				_this.edit_disdate = '';
				_this.disdate_arr = [];
				// 适用日期
				_this.edit_use_date = '不限制';
				_this.enable_start_time = '';
				_this.enable_end_time = '';
				$(_this.$refs.edit_is_discount).val(-1).trigger("change");
				_this.edit_serv_perc = '';
				_this.edit_forecast_cost = '';
				_this.edit_gross_ratio = '';
				$(_this.$refs.edit_is_cshow).val('').trigger("change");
				$(_this.$refs.edit_is_dt).val('').trigger("change");
				$(_this.$refs.edit_is_give_ratio).val('').trigger("change");
				$(".radio-choose").find("input[name='isOpenBox']").eq(0).prop("checked", "true");
				$(".radio-choose").find("input[name='isrenew']").eq(0).prop("checked", "true");
				$(".radio-choose").find("input[name='isCrossTime']").eq(1).prop("checked", "true");
				$(".radio-choose").find("input[name='can_scene_buy']").eq(1).prop("checked", "true");
				_this.vip_level1_price = '';
				_this.vip_level2_price = '';
				_this.vip_level3_price = '';
				_this.vip_level4_price = '';
				_this.vip_level5_price = '';
				_this.vip_level6_price = '';
				_this.vip_level7_price = '';
				_this.vip_level8_price = '';
				_this.vip_level9_price = '';
				_this.vip_level10_price = '';
				$(_this.$refs.edit_book_wrap).hide();
				_this.edit_book_num = '';
				_this.edit_book_discount = '';
				_this.book_vip_level1_price = '';
				_this.book_vip_level2_price = '';
				_this.book_vip_level3_price = '';
				_this.book_vip_level4_price = '';
				_this.book_vip_level5_price = '';
				_this.book_vip_level6_price = '';
				_this.book_vip_level7_price = '';
				_this.book_vip_level8_price = '';
				_this.book_vip_level9_price = '';
				_this.book_vip_level10_price = '';
				_this.edit_book_remark = '';
				_this.showList = false;
			},
			// 获取套餐名称
			getPackageName(shop_id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "publicData/api_getPackageInfo",
					crossDomain: true,
					async: false,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result.data, function(k, v) {
								arr.push({ id: v.id, text: v.name, type: v.type, type_name: v.type_name, time: v.time, goods_price: v.goods_price });
							});

							$(_this.$refs.edit_name).select2({
								data: arr,
								allowClear: true,
								language: "zh-CN",
								minimumResultsForSearch: -1,
								width: '100%'
							}).on("select2:select", function(e) {
								_this.edit_type = e.params.data.type_name;
								_this.edit_duration_minute = e.params.data.time;
								_this.edit_pkg_price = e.params.data.goods_price;
								if(e.params.data.type == '4') {
									$(_this.$refs.edit_group_price).prop("disabled", false);
									$(_this.$refs.eidt_is_book).val(-1).trigger("change");
									$(_this.$refs.edit_book_wrap).show();
									_this.showHolidayBookBlock = true
								} else {
									$(_this.$refs.edit_group_price).attr("disabled", true);
									$(_this.$refs.edit_book_wrap).hide();
									_this.showHolidayBookBlock = false
								}
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 填写团购结算价
			fillGroupPop: function() {
				let _this = this;

				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: ['团购结算价', true],
					area: ['600px', ''],
					content: $(_this.$refs.pkg_group_pop),
					offset: '100px'
				}, function() {
					let newArr = [];
					_this.pkg_groups = {}
					$.each(_this.group_type_list, (index, item) => {
						let str = item.name + (item.price == "" ? '0' : item.price)
						newArr.push(str)
						_this.pkg_groups[item.id] = item.price == "" ? '0' : item.price
					})
					_this.edit_group_price = newArr.join();
					layer.closeAll();
				});
			},
			// 选择包厢类型
			editBoxTypeFun: function() {
				let _this = this;
				
				let c_boxtype_item = _this.boxtype_item;
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], //按钮
					title: '包厢类型',
					area: ['600px', ''], //宽高
					content: $(_this.$refs.boxtype_alert)
				}, function() {
					let texts = [];
					_this.boxtype_arr.forEach(function(item) {
						_this.boxtype_item.forEach(function(item2) {
							if(item.id == item2){
								texts.push(item.name);
							}
						});
					});
					_this.edit_box_type = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_box_type != "") {
						_this.boxtype_item = c_boxtype_item;
						return;
					}
					_this.boxtype_item = [];
				});
			},
			// 包厢类型全选
			boxtypeAll: function() {
				let _this = this;
				_this.boxtype_all = _this.c_boxtype_all;
				if(!_this.boxtype_all) { // 实现全选
					_this.boxtype_item = [];
					_this.boxtype_arr.forEach(function(item) {
					    _this.boxtype_item.push(item.id);
					});
				} else { // 实现反选
					_this.boxtype_item = [];
				}
			},
			// 小时分钟初始化
			selectTime: function() {
				let _this = this;
				// let seconds = [];
				// for(let i = 0; i < 60; i++) {
				// 	let item = {};
				// 	item.id = (i < 10) ? '0' + i : i;
				// 	item.text = (i < 10) ? '0' + i : i;
				// 	seconds[i] = item;
				// };
				let seconds = [{id: '00', text: '00'}, {id: '30', text: '30'}];
				let hour = [];
				for(let i = 0; i < 24; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					hour[i] = item;
				}
				$(_this.$refs.starthour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.startseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stophour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stopseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				})
			},
			// 选择使用时间
			editUseTimeFun: function() {
				let _this = this;
				$(_this.$refs.starthour).val(_this.use_time_start.split(':')[0]).trigger('change');
				$(_this.$refs.startseconds).val(_this.use_time_start.split(':')[1]).trigger('change');
				$(_this.$refs.stophour).val(_this.use_time_end.split(':')[0]).trigger('change');
				$(_this.$refs.stopseconds).val(_this.use_time_end.split(':')[1]).trigger('change');
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: '使用时间选择',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.pprice_use_time)
				}, function() {
					let starthour = $(_this.$refs.starthour).select2("val");
					let startseconds = $(_this.$refs.startseconds).select2("val");
					let stophour = $(_this.$refs.stophour).select2("val");
					let stopseconds = $(_this.$refs.stopseconds).select2("val");
					_this.use_time_start = starthour + ":" + startseconds;
					_this.use_time_end = stophour + ":" + stopseconds;
					layer.closeAll();
				});
			},
			// 选择星期
			editWeekFun: function() {
				let _this = this;
				let c_week_item = _this.week_item;
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['有效星期日', true],
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.week_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.edit_week_txt != "") {
							_this.week_item = c_week_item;
							return;
						}
						_this.week_item = [];
					}
				}, function() {
					let texts = [];
					_this.week_arr.forEach(function(item) {
						_this.week_item.forEach(function(item2) {
							if(item.id == item2){
								texts.push(item.name);
							}
						});
					});
					_this.edit_week_txt = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_week_txt != "") {
						_this.week_item = c_week_item;
						return;
					}
					_this.week_item = [];
				});
			},
			// 全选
			weekAll: function() {
				let _this = this;
				_this.week_all = _this.c_week_all;
				if(!_this.week_all) { // 实现全选
					_this.week_item = [];
					_this.week_arr.forEach(function(item) {
						_this.week_item.push(item.id);
					});
				} else { // 实现反选
					_this.week_item = [];
				}
			},
			// 获取详情
			getDet(type) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": _this.edit_id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/getPriceSetDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let det = data.response.result.data;
                            console.log('det', det);
							if(type == "copy_add") {
								// 进入复制新增页
								_this.modify = "add";
								$(_this.$refs.edit_shop).prop("disabled", false);
								$(_this.$refs.edit_shop).val(det.shop_id).trigger('change');
								_this.edit_listorder = '';
								// 套餐名称
								$(_this.$refs.edit_name).html('<option value=""></option>');
								$(_this.$refs.edit_name).prop("disabled", false);
								_this.getPackageName(det.shop_id);
								$(_this.$refs.edit_name).val(det.package_id).trigger('change');
								// 套餐类型
								_this.edit_type = det.type_name;
								_this.edit_duration_minute = det.package_time;
								// 时长原价
								_this.edit_duration_price = det.time_cost_price;
								// 时间成本价
								_this.edit_time_cost = det.time_prime_price;
								_this.edit_pkg_price = det.goods_price;
								_this.edit_discount_price = det.actual_price;
								_this.edit_vip_price = det.vip_price;
								// 团购结算价
								if(det.package_type == '4') {
									$(_this.$refs.edit_group_price).prop("disabled", false);
									_this.pkg_groups = det.groups
									let newArr = [];
									$.each(_this.group_type_list, (index, item) => {
										for(let key in _this.pkg_groups){
											if (item.id == key) {
												item.price = _this.pkg_groups[key]
												let str = item.name + _this.pkg_groups[key]
												newArr.push(str)
											}
										}
									})
									_this.edit_group_price = newArr.join();
								} else {
									$(_this.$refs.edit_group_price).prop("disabled", true);
									_this.pkg_groups = {};
									_this.edit_group_price = '';
								}
								// 适用包厢类型
								$(_this.$refs.edit_box_type).prop("disabled", false);
								_this.getBoxType(det.shop_id, 'edit');
								_this.edit_box_type = det.room_type_name;
								_this.boxtype_item = [];
								_this.boxtype_item.push(det.room_type);
								_this.use_time_start = det.start_time;
								_this.use_time_end = det.end_time;
								_this.edit_week_txt = det.week_cycle_str;
								_this.week_item = det.week_cycle.split(',');
								// 不可用日期
								_this.edit_disdate = det.disabled_date;
								_this.disdate_arr = _this.edit_disdate.split(",");
								// 适用日期
								_this.enable_start_time = det.enable_start_time;
								_this.enable_end_time = det.enable_end_time;
								if(_this.enable_start_time == '') {
									_this.edit_use_date = '不限制';
								} else {
									_this.edit_use_date = _this.enable_start_time + ' - ' + _this.enable_end_time;
								}
								// 会员卡打折
								$(_this.$refs.edit_is_discount).val(det.discount_status).trigger("change");
								_this.edit_serv_perc = det.service_charge_rate;
								_this.edit_forecast_cost = det.forecast_cost_price;
								_this.edit_gross_ratio = det.gross_margin_ratio;
								// 消费者端是否显示
								$(_this.$refs.edit_is_cshow).val(det.customer_show).trigger("change");
								$(_this.$refs.edit_is_dt).val(det.outstanding).trigger("change");
								$(_this.$refs.edit_is_give_ratio).val(det.included_give_ratio).trigger("change");
								if(det.is_open_use == 1) {
									$(".radio-choose").find("input[name='isOpenBox']").eq(0).prop("checked", "true");
								} else {
									$(".radio-choose").find("input[name='isOpenBox']").eq(1).prop("checked", "false");
								}
								if(det.is_renew == 1) {
									$(".radio-choose").find("input[name='isrenew']").eq(0).prop("checked", "true");
								} else {
									$(".radio-choose").find("input[name='isrenew']").eq(1).prop("checked", "false");
								}
								if(det.consume_check == 1) {
									$(".radio-choose").find("input[name='isCrossTime']").eq(0).prop("checked", "true");
								} else {
									$(".radio-choose").find("input[name='isCrossTime']").eq(1).prop("checked", "false");
								}
								if(det.can_scene_buy == 1) {
									$(".radio-choose").find("input[name='can_scene_buy']").eq(0).prop("checked", "true");
								} else {
									$(".radio-choose").find("input[name='can_scene_buy']").eq(1).prop("checked", "false");
								}
								_this.vip_level1_price = det.vip_level1_price;
								_this.vip_level2_price = det.vip_level2_price;
								_this.vip_level3_price = det.vip_level3_price;
								_this.vip_level4_price = det.vip_level4_price;
								_this.vip_level5_price = det.vip_level5_price;
								_this.vip_level6_price = det.vip_level6_price;
								_this.vip_level7_price = det.vip_level7_price;
								_this.vip_level8_price = det.vip_level8_price;
								_this.vip_level9_price = det.vip_level9_price;
								_this.vip_level10_price = det.vip_level10_price;
								// 在线预定
								if (det.package_type == '4') {
									$(_this.$refs.eidt_is_book).val(det.book_open).trigger("change");
									if(det.book_open == '1') {
										_this.edit_book_num = det.book_day_num;
										_this.edit_book_discount = det.book_actual_price;
										_this.book_vip_level1_price = det.book_vip_level1_price;
										_this.book_vip_level2_price = det.book_vip_level2_price;
										_this.book_vip_level3_price = det.book_vip_level3_price;
										_this.book_vip_level4_price = det.book_vip_level4_price;
										_this.book_vip_level5_price = det.book_vip_level5_price;
										_this.book_vip_level6_price = det.book_vip_level6_price;
										_this.book_vip_level7_price = det.book_vip_level7_price;
										_this.book_vip_level8_price = det.book_vip_level8_price;
										_this.book_vip_level9_price = det.book_vip_level9_price;
										_this.book_vip_level10_price = det.book_vip_level10_price;
										_this.edit_book_remark = det.book_remark;
									}
									$(_this.$refs.edit_book_wrap).show();
								} else {
									$(_this.$refs.edit_book_wrap).hide();
								}
								_this.showList = false;
							} else if(type == "edit") {
								// 进入详情页
								_this.modify = "edit";
                                // 同步资料的门店
                                _this.shop_list = det.shop_info.map(item => {
                                    return {
                                        id: item.id,
                                        text: item.name
                                    }
                                }).filter(item => item.id != det.shop_id);
                                // 默认全选
                                _this.selected_shops = _this.shop_list.map(item => item.id);
								$(_this.$refs.edit_shop).val(det.shop_id).trigger('change');
								$(_this.$refs.edit_shop).prop("disabled", true);
								_this.edit_listorder = det.listorder;
								$(_this.$refs.edit_name).html('<option value=""></option>');
								_this.getPackageName(det.shop_id);
								$(_this.$refs.edit_name).val(det.package_id).trigger('change');
								$(_this.$refs.edit_name).prop("disabled", true);
								_this.edit_type = det.type_name;
								_this.edit_duration_minute = det.package_time;
								_this.edit_duration_price = det.time_cost_price;
								// 时间成本价
								_this.edit_time_cost = det.time_prime_price;
								_this.edit_pkg_price = det.goods_price;
								_this.edit_discount_price = det.actual_price;
								_this.edit_vip_price = det.vip_price;
								// 团购结算价
								if(det.package_type == '4') {
									$(_this.$refs.edit_group_price).prop("disabled", false);
									_this.pkg_groups = det.groups
									let newArr = [];
									$.each(_this.group_type_list, (index, item) => {
										for(let key in _this.pkg_groups){
											if (item.id == key) {
												item.price = _this.pkg_groups[key]
												let str = item.name + _this.pkg_groups[key]
												newArr.push(str)
											}
										}
									})
									_this.edit_group_price = newArr.join();
								} else {
									$(_this.$refs.edit_group_price).attr("disabled", true);
									_this.pkg_groups = {};
									_this.edit_group_price = '';
								}
								// 适用包厢类型
								_this.getBoxType(det.shop_id, 'edit');
								_this.edit_box_type = det.room_type_name;
								_this.boxtype_item = [];
								_this.boxtype_item.push(det.room_type);
								$(_this.$refs.edit_box_type).prop("disabled", true);
								_this.use_time_start = det.start_time;
								_this.use_time_end = det.end_time;
								// 星期
								_this.edit_week_txt = det.week_cycle_str;
								_this.week_item = det.week_cycle.split(',');
								// 不可用日期
								_this.edit_disdate = det.disabled_date;
								_this.disdate_arr = _this.edit_disdate.split(",");
								// 适用日期
								_this.enable_start_time = det.enable_start_time;
								_this.enable_end_time = det.enable_end_time;
								if(_this.enable_start_time == '') {
									_this.edit_use_date = '不限制';
								} else {
									_this.edit_use_date = _this.enable_start_time + ' - ' + _this.enable_end_time;
								}
								$(_this.$refs.edit_is_discount).val(det.discount_status).trigger("change");
								_this.edit_serv_perc = det.service_charge_rate;
								_this.edit_forecast_cost = det.forecast_cost_price;
								_this.edit_gross_ratio = det.gross_margin_ratio;
								$(_this.$refs.edit_is_cshow).val(det.customer_show).trigger("change");
								$(_this.$refs.edit_is_dt).val(det.outstanding).trigger("change");
								$(_this.$refs.edit_is_give_ratio).val(det.included_give_ratio).trigger("change");
								if(det.is_open_use == 1) {
									$(".radio-choose").find("input[name='isOpenBox']").eq(0).prop("checked", "true");
								} else {
									$(".radio-choose").find("input[name='isOpenBox']").eq(1).prop("checked", "false");
								}
								if(det.is_renew == 1) {
									$(".radio-choose").find("input[name='isrenew']").eq(0).prop("checked", "true");
								} else {
									$(".radio-choose").find("input[name='isrenew']").eq(1).prop("checked", "false");
								}
								if(det.consume_check == 1) {
									$(".radio-choose").find("input[name='isCrossTime']").eq(0).prop("checked", "true");
								} else {
									$(".radio-choose").find("input[name='isCrossTime']").eq(1).prop("checked", "false");
								}
								if(det.can_scene_buy == 1) {
									$(".radio-choose").find("input[name='can_scene_buy']").eq(0).prop("checked", "true");
								} else {
									$(".radio-choose").find("input[name='can_scene_buy']").eq(1).prop("checked", "false");
								}
								_this.vip_level1_price = det.vip_level1_price;
								_this.vip_level2_price = det.vip_level2_price;
								_this.vip_level3_price = det.vip_level3_price;
								_this.vip_level4_price = det.vip_level4_price;
								_this.vip_level5_price = det.vip_level5_price;
								_this.vip_level6_price = det.vip_level6_price;
								_this.vip_level7_price = det.vip_level7_price;
								_this.vip_level8_price = det.vip_level8_price;
								_this.vip_level9_price = det.vip_level9_price;
								_this.vip_level10_price = det.vip_level10_price;
								// 微信预定
								if (det.package_type == 4) {
									$(_this.$refs.eidt_is_book).val(det.book_open).trigger("change");
									if(det.book_open == '1') {
										_this.edit_book_num = det.book_day_num;
										_this.edit_book_discount = det.book_actual_price;
										_this.book_vip_level1_price = det.book_vip_level1_price;
										_this.book_vip_level2_price = det.book_vip_level2_price;
										_this.book_vip_level3_price = det.book_vip_level3_price;
										_this.book_vip_level4_price = det.book_vip_level4_price;
										_this.book_vip_level5_price = det.book_vip_level5_price;
										_this.book_vip_level6_price = det.book_vip_level6_price;
										_this.book_vip_level7_price = det.book_vip_level7_price;
										_this.book_vip_level8_price = det.book_vip_level8_price;
										_this.book_vip_level9_price = det.book_vip_level9_price;
										_this.book_vip_level10_price = det.book_vip_level10_price;
										_this.edit_book_remark = det.book_remark;
										_this.showHolidayBookBlock = true
									}
									$(_this.$refs.edit_book_wrap).show();
								} else {
									$(_this.$refs.edit_book_wrap).hide();
									_this.showHolidayBookBlock = false
								}
								_this.showList = false;
								_this.holiday_page = 1;
								_this.getHoladayList(_this.holiday_page)
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			saveEdit() {
				let _this = this;
				// 先判断不为空
				if($(_this.$refs.edit_name).val() != "") {
					if(_this.edit_duration_price != "") {
						if(_this.edit_discount_price != "") {
							if(_this.week_item != []) {
								if(_this.modify == "edit") {
									if(_this.selected_shops.length > 0) {
										// 弹窗二次确认
										layer.confirm('<span style="color: red;">当前资料修改将同步至其他门店，是否继续保存?若不需要同步，请重新勾选资料同步门店!</span>', {
											btn: ['继续保存', '取消']
										}, function() {
											_this.updatePackagePrice(4);
										});
									} else {
										_this.updatePackagePrice(4);
									}
								} else {
									_this.addPackagePrice();
								}
							} else {
								layer.msg("请输入有效星期日");
							}
						} else {
							layer.msg("请输入优惠价");
						}
					} else {
						layer.msg("请输入时长原价");
					}
				} else {
					layer.msg("请输入套餐名称");
				}
			},
			// 添加
			addPackagePrice() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"package_id": $(_this.$refs.edit_name).val(),
							"shop_id": $(_this.$refs.edit_shop).val(),
							"listorder": _this.edit_listorder,
							"room_type": _this.boxtype_item,
							"time_cost_price": _this.edit_duration_price,
							"price": _this.edit_original_cost,
							"actual_price": _this.edit_discount_price,
							"vip_price": _this.edit_vip_price,
							"time_prime_price": _this.edit_time_cost,
							"group_purchase_price": _this.edit_group_price,
							"groups": _this.pkg_groups,
							"start_time": _this.use_time_start,
							"end_time": _this.use_time_end,
							"week_cycle": _this.week_item.join(),
							"disabled_date": _this.edit_disdate,
							"enable_start_time": _this.enable_start_time,
							"enable_end_time": _this.enable_end_time,
							"discount_status": $(_this.$refs.edit_is_discount).val(),
							"service_charge_rate": _this.edit_serv_perc,
							"forecast_cost_price": _this.edit_forecast_cost,
							"gross_margin_ratio": _this.edit_gross_ratio,
							"customer_show": $(_this.$refs.edit_is_cshow).val(),
							"outstanding": $(_this.$refs.edit_is_dt).val(),
							"included_give_ratio": $(_this.$refs.edit_is_give_ratio).val(),
							"is_open_use": $(".radio-choose").find("input[name='isOpenBox']").eq(0).prop("checked") == true ? 1 : -1,
							"is_renew": $(".radio-choose").find("input[name='isrenew']").eq(0).prop("checked") == true ? 1 : -1,
							"consume_check_time": $(".radio-choose").find("input[name='isCrossTime']").eq(0).prop("checked") == true ? 1 : -1,
							"can_scene_buy": $(".radio-choose").find("input[name='can_scene_buy']").eq(0).prop("checked") == true ? 1 : -1,
							"vip_level1_price": _this.vip_level1_price,
							"vip_level2_price": _this.vip_level2_price,
							"vip_level3_price": _this.vip_level3_price,
							"vip_level4_price": _this.vip_level4_price,
							"vip_level5_price": _this.vip_level5_price,
							"vip_level6_price": _this.vip_level6_price,
							"vip_level7_price": _this.vip_level7_price,
							"vip_level8_price": _this.vip_level8_price,
							"vip_level9_price": _this.vip_level9_price,
							"vip_level10_price": _this.vip_level10_price,
                            "shop_ids": _this.selected_shops
						}
					},
					"comment": ""
				};
				if($(_this.$refs.eidt_is_book).val() == 1) {
					datas['request']['param']['book_open'] = $(_this.$refs.eidt_is_book).val();
					datas['request']['param']['book_day_num'] = _this.edit_book_num;
					datas['request']['param']['book_actual_price'] = _this.edit_book_discount;
					datas['request']['param']['book_vip_level1_price'] = _this.book_vip_level1_price;
					datas['request']['param']['book_vip_level2_price'] = _this.book_vip_level2_price;
					datas['request']['param']['book_vip_level3_price'] = _this.book_vip_level3_price;
					datas['request']['param']['book_vip_level4_price'] = _this.book_vip_level4_price;
					datas['request']['param']['book_vip_level5_price'] = _this.book_vip_level5_price;
					datas['request']['param']['book_vip_level6_price'] = _this.book_vip_level6_price;
					datas['request']['param']['book_vip_level7_price'] = _this.book_vip_level7_price;
					datas['request']['param']['book_vip_level8_price'] = _this.book_vip_level8_price;
					datas['request']['param']['book_vip_level9_price'] = _this.book_vip_level9_price;
					datas['request']['param']['book_vip_level10_price'] = _this.book_vip_level10_price;
					datas['request']['param']['book_remark'] = _this.edit_book_remark;
				}
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/setPackagePrice",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg("添加成功！");
                            _this.selected_shops = [];
                            _this.isAllSelected = false;
                            _this.shop_list = [];
							_this.initMainTable();
							_this.showList = true;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							if(data.response.result_status=="99"){
								layer.alert('', {
									title:'重复提示',
									skin: 'layer-repetition',
									content:'<p class="tip">以下时间重复,请重新设置</p><p class="tipcont">'+data.response.error_msg+'</p>'
								});
								return;
							}
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 更新
			updatePackagePrice: function(updateType) {
				let _this = this;
				let params = {};
				if(updateType == 1) { // 推荐
					params = {
						"id": _this.edit_id,
						"recommend": _this.pprice_recommend,
					}
				} else if(updateType == 2) { // 禁用启用、删除
					params = {
						"id": _this.edit_id,
						"status": _this.pprice_op,
					}
				} else if(updateType == 3) { // 预定上架
					params = {
						"id": _this.edit_id,
						"book_status": _this.pprice_book,
					}
				} else {
					params = {
						"id": _this.edit_id,
						"listorder": _this.edit_listorder,
						"price": _this.edit_original_cost,
						"room_type": _this.boxtype_item.join(),
						"time_cost_price": _this.edit_duration_price,
						"actual_price": _this.edit_discount_price,
						"vip_price": _this.edit_vip_price,
						"time_prime_price": _this.edit_time_cost,
						"group_purchase_price": _this.edit_group_price,
						"groups": _this.pkg_groups,
						"start_time": _this.use_time_start,
						"end_time": _this.use_time_end,
						"week_cycle": _this.week_item.join(),
						"disabled_date": _this.edit_disdate,
						"enable_start_time": _this.enable_start_time,
						"enable_end_time": _this.enable_end_time,
						"discount_status": $(_this.$refs.edit_is_discount).val(),
						"service_charge_rate": _this.edit_serv_perc,
						"forecast_cost_price": _this.edit_forecast_cost,
						"gross_margin_ratio": _this.edit_gross_ratio,
						"customer_show": $(_this.$refs.edit_is_cshow).val(),
						"outstanding": $(_this.$refs.edit_is_dt).val(),
						"included_give_ratio": $(_this.$refs.edit_is_give_ratio).val(),
						"is_open_use": $(".radio-choose").find("input[name='isOpenBox']").eq(0).prop("checked") == true ? 1 : -1,
						"is_renew": $(".radio-choose").find("input[name='isrenew']").eq(0).prop("checked") == true ? 1 : -1,
						"consume_check_time": $(".radio-choose").find("input[name='isCrossTime']").eq(0).prop("checked") == true ? 1 : -1,
						"can_scene_buy": $(".radio-choose").find("input[name='can_scene_buy']").eq(0).prop("checked") == true ? 1 : -1,
						"vip_level1_price": _this.vip_level1_price,
						"vip_level2_price": _this.vip_level2_price,
						"vip_level3_price": _this.vip_level3_price,
						"vip_level4_price": _this.vip_level4_price,
						"vip_level5_price": _this.vip_level5_price,
						"vip_level6_price": _this.vip_level6_price,
						"vip_level7_price": _this.vip_level7_price,
						"vip_level8_price": _this.vip_level8_price,
						"vip_level9_price": _this.vip_level9_price,
						"vip_level10_price": _this.vip_level10_price,
                        "shop_ids": _this.selected_shops
					}
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": params
					},
					"comment": ""
				};
				// 预定
				if(updateType == 4) {
					if(_this.edit_type == '团购套餐') {
						datas['request']['param']['book_open'] = $(_this.$refs.eidt_is_book).val();
						datas['request']['param']['book_day_num'] = _this.edit_book_num;
						datas['request']['param']['book_actual_price'] = _this.edit_book_discount;
						datas['request']['param']['book_vip_level1_price'] = _this.book_vip_level1_price;
						datas['request']['param']['book_vip_level2_price'] = _this.book_vip_level2_price;
						datas['request']['param']['book_vip_level3_price'] = _this.book_vip_level3_price;
						datas['request']['param']['book_vip_level4_price'] = _this.book_vip_level4_price;
						datas['request']['param']['book_vip_level5_price'] = _this.book_vip_level5_price;
						datas['request']['param']['book_vip_level6_price'] = _this.book_vip_level6_price;
						datas['request']['param']['book_vip_level7_price'] = _this.book_vip_level7_price;
						datas['request']['param']['book_vip_level8_price'] = _this.book_vip_level8_price;
						datas['request']['param']['book_vip_level9_price'] = _this.book_vip_level9_price;
						datas['request']['param']['book_vip_level10_price'] = _this.book_vip_level10_price;
						datas['request']['param']['book_remark'] = _this.edit_book_remark;
					}
				}
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/updatePackageSet",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(updateType == 4) {
								layer.msg(data.response.error_msg);
								_this.showList = true;
							}
							$(_this.$refs.pprice_list).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							if(data.response.result_status == "99") {
								layer.alert('', {
									title: '重复提示',
									skin: 'layer-repetition',
									content: '<p class="tip">以下时间重复,请重新设置</p><p class="tipcont">'+ data.response.error_msg +'</p>'
								});
								return;
							}
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			backList() {
				this.showList = true;
			},

			getHoladayList(page) {
				let _this = this;

				_this.holiday_loading = true;
				Vue.axios.post('roomPackage/getHolidayList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"relation_id": _this.edit_id,
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.holiday_total = Number(res.data.response.result.total)
						}
						_this.holiday_list = res.data.response.result.rows;
						_this.holiday_loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 点击"新增"节假日价格设置
			addNewHolidayPrice() {
				let _this = this 
				_this.holiday_add_form = {
					relation_id: _this.edit_id,
					name: '',
					enable_start_time: '',
					enable_end_time: '',
					timeStr: '',
					actual_price: '', // 优惠价
					vip_price: '', // 会员价
					vip_level1_price: '', //会员等级价格
					vip_level2_price: '',
					vip_level3_price: '',
					vip_level4_price: '',
					vip_level5_price: '',
					vip_level6_price: '',
					vip_level7_price: '',
					vip_level8_price: '',
					vip_level9_price: '',
					vip_level10_price: '',
					book_actual_price: '', // 预定价格
					book_vip_level1_price: '', // 预定会员等级价格
					book_vip_level2_price: '', 
					book_vip_level3_price: '', 
					book_vip_level4_price: '', 
					book_vip_level5_price: '', 
					book_vip_level6_price: '', 
					book_vip_level7_price: '', 
					book_vip_level8_price: '', 
					book_vip_level9_price: '', 
					book_vip_level10_price: '', 
				}

				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['节假日价格设置', true],
                    area: ['900px', '550px'], // 宽高
                    content: $(_this.$refs.holiday_pop),
                }, function() {
                	if (_this.holiday_add_form.name == '') {
                		layer.msg("请先输入节假日名称")
                		return
                	}
                	if (_this.holiday_add_form.enable_start_time == '') {
                		layer.msg("请先选择适用日期")
                		return
                	}
                	if (_this.holiday_add_form.actual_price == '') {
                		layer.msg("请先输入优惠价")
                		return
                	}
                    Vue.axios.post('roomPackage/addHolidayData', {
						"header": Vue.request_header,
						"request": {
							"param": _this.holiday_add_form
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.closeAll()
							layer.msg("新增成功！")
							_this.holiday_page = 1
							_this.getHoladayList(_this.holiday_page)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
                });

                _this.$nextTick(() => {
                	_this.innitHolidayDate()
                })
			},

			// 初始化节假日价格设置弹窗日期插件
            innitHolidayDate: function() {
                let _this = this;
                $(_this.$refs.holiday_time).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.holiday_add_form.enable_start_time = start.format('YYYY-MM-DD 08:00');
                    _this.holiday_add_form.enable_end_time = end.format('YYYY-MM-DD 08:00');
                    _this.holiday_add_form.timeStr = _this.holiday_add_form.enable_start_time + '~' + _this.holiday_add_form.enable_end_time
                });
            },

            // 修改节假日价格设置
            editHoliday(row) {
            	let _this = this
                
			
				_this.holiday_add_form = {
					id: row.id,
					relation_id: _this.edit_id,
					name: row.name,
					enable_start_time: row.enable_start_time,
					enable_end_time: row.enable_end_time,
					timeStr:  row.enable_start_time + '~' + row.enable_end_time,
					actual_price: row.actual_price, // 优惠价
					vip_price: row.vip_price, // 会员价
					vip_level1_price: row.vip_level1_price, //会员等级价格
					vip_level2_price: row.vip_level2_price,
					vip_level3_price: row.vip_level3_price,
					vip_level4_price: row.vip_level4_price,
					vip_level5_price: row.vip_level5_price,
					vip_level6_price: row.vip_level6_price,
					vip_level7_price: row.vip_level7_price,
					vip_level8_price: row.vip_level8_price,
					vip_level9_price: row.vip_level9_price,
					vip_level10_price: row.vip_level10_price,
					book_actual_price: row.book_actual_price, // 预定价格
					book_vip_level1_price: row.book_vip_level1_price, // 预定会员等级价格
					book_vip_level2_price: row.book_vip_level2_price, 
					book_vip_level3_price: row.book_vip_level3_price, 
					book_vip_level4_price: row.book_vip_level4_price, 
					book_vip_level5_price: row.book_vip_level5_price, 
					book_vip_level6_price: row.book_vip_level6_price, 
					book_vip_level7_price: row.book_vip_level7_price, 
					book_vip_level8_price: row.book_vip_level8_price, 
					book_vip_level9_price: row.book_vip_level9_price, 
					book_vip_level10_price: row.book_vip_level10_price, 
				}

				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['节假日价格设置', true],
                    area: ['900px', '550px'], // 宽高
                    content: $(_this.$refs.holiday_pop),
                }, function() {
                	if (_this.holiday_add_form.name == '') {
                		layer.msg("请先输入节假日名称")
                		return
                	}
                	if (_this.holiday_add_form.enable_start_time == '') {
                		layer.msg("请先选择适用日期")
                		return
                	}
                	if (_this.holiday_add_form.actual_price == '') {
                		layer.msg("请先输入优惠价")
                		return
                	}
                    Vue.axios.post('roomPackage/editHolidayData', {
						"header": Vue.request_header,
						"request": {
							"param": _this.holiday_add_form
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.closeAll()
							layer.msg("修改成功！")
							_this.getHoladayList(_this.holiday_page)
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					});
                });

                _this.$nextTick(() => {
                	_this.innitHolidayDate()
                })
            },

            // 删除节假日价格设置
            delHoliday(id) {
	            let _this = this 

	            layer.confirm('删除后数据将不可恢复！确认删除？', {
	                btn: ['确定', '取消'],
	                title: '提示',
	            }, function() {
	                Vue.axios.post('roomPackage/delHolidayData', {
	                    "header": Vue.request_header,
	                    "request": {
	                        "param": {
	                            "id": id
	                        }
	                    },
	                    "comment": ""
	                })
	                .then(res => {
	                    layer.closeAll()
	                    if(res.data.response.result_code == "true") {
	                        layer.msg('操作成功');
	                        _this.getHoladayList(_this.holiday_page)
	                    } else {
	                        Vue.timeoutfun(res.data.response.result_status, _this);
	                        layer.msg(res.data.response.error_msg);
	                    }
	                })
	                .catch(err => {
	                    layer.msg('出错啦');
	                });
	            });
	        },

	        // 点击上传xls文件
	        addXlsFun: function() {
	            this.$refs.xlsFile.click();
	        },
	        // 上传
	        uploadXls: function(e) {
	            let _this = this;

	            let formData = new FormData();
	            formData.append("packageFile", $("#xlsFile")[0].files[0]);
	            // 清除file
	            let obj = document.getElementById('xlsFile');
	            obj.value = '';

	            $.ajax({
	                type: "post",
	                dataType: "json",
	                processData: false,
	                contentType: false,
	                url: Vue.ctUrl + "RoomPackage/importData",
	                crossDomain: true,
	                xhrFields: {
	                    withCredentials: true
	                },
	                data: formData,
	                success: function(data) {
	                    if(data.response.result_code == "true") {
	                        layer.msg('导入成功');
	                        $(_this.$refs.pprice_list).bootstrapTable('refresh');
	                    } else {
	                        Vue.timeoutfun(data.response.result_status, _this);
	                        layer.open({
	                            type: 1,
	                            title: '导入失败，数据错误，请修正数据后重新导入！',
	                            skin: 'import-err',
	                            area: ['700px', ''],
	                            content: data.response.error_msg
	                        })
	                    }
	                },
	                error: function(err) {
	                    layer.msg("网络原因");
	                }
	            });
	        },
			handleSelectAllShops(val) {
				if (val) {
					this.selected_shops = this.shop_list.map(shop => shop.id);
				} else {
					this.selected_shops = [];
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.lineThrough {
		text-decoration: line-through;
	}
	.pprice-list {
		.pull-right {
			button {
				margin: 0 0 0 30px;
			}
		}
		.recommend-bg {
			background: url(../../assets/images/recommend.png) no-repeat;
			background-position: bottom right;
		}
		.bigbtn {
			margin-right: 20px;
			a {
				text-decoration: none;
				color: #fff;
			}
		}
		#xlsFile {
			display: none;
		}
	}
	.pprice-edit {
		.kfpkg-vip-hint {
			position: absolute;
			right: -230px;
			top: 8px;
			color: #F00;
		}
		.pkg-use-time {
			position: relative;
		}
		.radio-choose {
			label {
				margin-right: 50px;
				color: #606060;
				font-size: 14px;
				font-weight: normal;
			}
		}
		.pkg-group-pop {
			display: none;
			// width: 70%;
			margin: 20px auto;
			// label {
			// 	padding: 0;
			// 	line-height: 32px;
			// 	color: #5e5e5e;
			// 	font-size: 14px;
			// 	text-align: right;
			// 	font-weight: normal;
			// }
			// .row {
			// 	margin: 0 0 20px;
			// }
			// .icon-link {
			// 	float: left;
			// 	width: 5px;
			// 	line-height: 32px;
			// }
			.el-input {
				width: 320px;
				margin-left: 10px;
			}
		}
		.set-price-row {
			padding: 20px 0 0;
			border-top: 1px solid #CCC;
			.book-remark {
				resize: none;
				height: 140px !important;
				padding: 6px 20px;
				margin: 0 0 30px;
			}
		}
		.block-title {
			text-align: center;
			font-size: 22px;
			font-weight: bold;
			// margin: 20px;
		}
		.holiday-table {
			margin-top: 20px;
		}
	}
	.layer-repetition {
		.layui-layer-title {
            padding: 0;
		}
		.tip {
			text-align: center;
			color:#5e5e5e;
			font-size: 16px;
		}
		.tipcont {
			text-align: center;
			font-size: 14px;
			color: red;
		}
	}
	// 节假日价格设置弹窗
	.holiday-pop {
		.el-input {
			width: 280px;
		}
		.pop-block-title {
			margin: 10px 20px 20px 20px;
		}
	}

	// 批量修改
	.multi-set-pop {
    	.el-select,
    	.el-input {
    		width: 300px;
    	}
    	.red-tip {
    		margin-bottom: 20px;
    		color: red;
    	}
    	.row {
            clear: both;
            margin: 0 0 20px;
        }
        .el-checkbox {
            float: left;
            margin-top: 10px;
        }
        .el-form-item__label {
            width: 124px;
            text-align: left;
        }
        .beyond {
            line-height: 20px;
        }
        .el-input {
            width: 300px;
        }
        .el-input__inner {
            height: 40px!important;
        }
    }
    .select-header {
        margin-bottom: 10px;
    }

    .shop-sync-message {
        width: 100%;
        background-color: #f5f5f5;
        border-radius: 4px;
        padding: 20px;
        margin-bottom: 20px;
        .shop-sync-message-title {
            font-size: 20px;
            margin-bottom: 10px;
            .shop-sync-message-title-span {
                font-size: 14px;
                color: #999;
            }
        }
    }
    .shop-checkbox-group {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    align-items: start;
}

.shop-checkbox-item {
    margin-right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>